import { SessionConfigDefaultsSource } from "../@types"
import {
  createPlatformDefaultsConfig,
  PlatformDefaults,
} from "./platformDefaults"

/**
 * Not much here right now. Check git history to see how this interface is used to
 * support introduction of new client features.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Defaults {
  platformDefaults: PlatformDefaults
}

export const createDefaultsConfig: (
  source: SessionConfigDefaultsSource,
) => Defaults = (s) => new DefaultsImpl(s)

class DefaultsImpl implements Defaults {
  private _platformDefaults: PlatformDefaults
  constructor(source: SessionConfigDefaultsSource) {
    /* eslint-disable @typescript-eslint/dot-notation */
    this._platformDefaults = createPlatformDefaultsConfig(
      source["platform"] || {},
    )
    /* eslint-enable @typescript-eslint/dot-notation */
  }
  get platformDefaults() {
    return this._platformDefaults
  }
}
